<template>
  <div>
    <div id="adbox" ref="adbox" v-show="showAdbox" @mouseenter="enterBox" @mouseleave="leaveBox">
      <a @click="more()">
        <img src="@/assets/mark.jpg" alt="广告图片">
      </a>
      <b @click="closeBox">Ⅹ</b>
    </div>
    <Header></Header>
    <nav>
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" style="width:1200px;margin: 0 auto;height: 39px">
        <el-menu-item index="1">国际化发展</el-menu-item>
        <el-menu-item index="2">北京市布局</el-menu-item>
      </el-menu>
    </nav>
        <div class="centerWidth100">
      <div class="Center1200">
        <div class="conHeader">
          <el-form :model="form" ref="form" label-width="100px" label-position="right">
            <el-form-item label="所属区：" class="width45">
              <el-select v-model="form.district" clearable filterable placeholder="请选择">
                <el-option v-for="(item,Key) in districtsList" :key="Key" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="行业类别：" class="width45">
              <el-select v-model="form.industryType" clearable placeholder="请选择">
                <el-option v-for="(item,Key) in industryList" :key="Key" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="企业名称：" class="width45">
              <el-input v-model="form.name" placeholder="请输入企业名称"></el-input>
            </el-form-item>
            <el-form-item class="width6">
              <el-button type="primary" size="small" @click="searchData()" plain>查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="conBottom">
          <el-row class="tac">
            <el-col style="min-width:280px;max-height:682px">
              <el-menu
                :default-active="Flag == '' ? '1-0' : Flag + '-0'"
                :default-openeds="['' + Flag]"
                :unique-opened="true" class="el-menu-vertical-demo" background-color="#fbe1be" text-color="black"
                @open="handleOpen"
                active-text-color="#731f36">
                <el-submenu index="1">
                  <template slot="title">
                    <span>会计咨询</span>
                  </template>
                  <el-menu-item-group style="max-height: 456px;overflow: hidden;overflow-y: auto;">
                    <el-menu-item v-for="(item, Key) in MenuList1" :key="Key" @click="clickMenu(item, 1)" :index="'1-' + Key">{{ item.name }}</el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
                <el-submenu index="2">
                  <template slot="title">
                    <span>法律服务</span>
                  </template>
                  <el-menu-item-group style="max-height: 456px;overflow: hidden;overflow-y: auto;">
                    <el-menu-item v-for="(item, Key) in MenuList2" :key="Key" @click="clickMenu(item, 2)" :index="'2-' + Key">{{ item.name }}</el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
                <el-submenu index="3">
                  <template slot="title">
                    <span>人力资源</span>
                  </template>
                  <el-menu-item-group style="max-height: 456px;overflow: hidden;overflow-y: auto;">
                    <el-menu-item v-for="(item, Key) in MenuList3" :key="Key" @click="clickMenu(item, 3)" :index="'3-' + Key">{{ item.name }}</el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
                <el-submenu index="4">
                  <template slot="title">
                    <span>广告营销</span>
                  </template>
                  <el-menu-item-group style="max-height: 456px;overflow: hidden;overflow-y: auto;">
                    <el-menu-item v-for="(item, Key) in MenuList4" :key="Key" @click="clickMenu(item, 4)" :index="'4-' + Key">{{ item.name }}</el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
              </el-menu>
            </el-col>
          </el-row>
          <div class="Right">
            <div class="mapDivTop">
              <h2 v-if="MapDivTop.name">{{ MapDivTop.name }}
                <p v-if="MapDivTop.industryTypeName">
                  {{ MapDivTop.industryTypeName }}
                </p>
              </h2>
              <div v-if="MapDivTop.industryTypeName" @click="viewDetails">查看详情</div>
            </div>
            <div class="mapDiv" id="mapDiv">
              <div class="MapDiver">
                <div class='box'></div>
                <div class='box2'>在京主要办公地址示意图</div>
                <div class='box3'></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { entBJinfosApi,districtsApi } from "@/api/show/Display2";
import Header from '@/components/header.vue';

export default {
  name: "Display",
  components: {
    Header
  },
  data() {
    return {
      activeIndex: '2',
      x: 50,
      y: 50,
      xin: true,
      yin: true,
      step: 1,
      delay: 10,
      itl: null,
      showAdbox: true,
      MapDivTop: {},//点击左侧菜单地图上方显示的参数
      form: {},
      Flag: '1',
      MenuList1: [],
      MenuList2:[],
      MenuList3:[],
      MenuList4:[],
      regionList: [{
        name: '北京',
        value: 1
      }],
      industryList: [{
        name: '会计咨询',
        value: 3
      },{
        name: '法律服务',
        value: 2
      },{
        name: '人力资源',
        value: 1
      },{
        name: '广告营销',
        value: 4
      }],
      AMapAct:null,
      marker:null,
      districtsList: [],
      flagType: null
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.routeEnterShowAdbox()
    })
  },
  beforeRouteLeave(to, from, next) {
    next(vm => {
      vm.routeEnterShowAdbox()
    })
    clearInterval(this.itl);
  },
  created() {
    this.Flag = this.$route.query.type || '';
  },
  mounted() {
    districtsApi().then((res) => {//获取北京地区
      this.districtsList = res.data.data
    });
    this.searchData();
  },
  methods: {
    searchData() {
      let _this = this;
      this.MapDivTop = {}
      _this.Flag = '1';
      _this.MenuList1 = [];
      _this.MenuList2 = [];
      _this.MenuList3 = [];
      _this.MenuList4 = [];
      entBJinfosApi({params:_this.form}).then((res) => {//获取全部行业
        setTimeout(function(){
          _this.initMap();
        },500)
        var data = res.data.data
        if (data.length == 0) {
          _this.entCountryInfoVoList = ''
          _this.MapDivTop = {
            name: '此条件暂无数据'
          }
        }else{
          _this.MapDivTop = {}
          for(let i=0;i<data.length;i++) {
            data[i].flagType = i;
            if(data[i].industryName == '会计咨询') {
              _this.MenuList1.push(data[i])
            } else if(data[i].industryName == '法律服务') {
              _this.MenuList2.push(data[i])
            } else if(data[i].industryName == '人力资源') {
              _this.MenuList3.push(data[i])
            } else {
              _this.MenuList4.push(data[i])
            }
            setTimeout(function(){
              _this.Geocoder(data[i])
            },500)
          }
          if (_this.MenuList1.length) {
            _this.Flag = 1;
            _this.MapDivTop = _this.MenuList1[0];
          } else if (_this.MenuList2.length) {
            _this.Flag = 2;
            _this.MapDivTop = _this.MenuList2[0];
          } else if (_this.MenuList3.length) {
            _this.Flag = 3;
            _this.MapDivTop = _this.MenuList3[0];
          } else if (_this.MenuList4.length) {
            _this.Flag = 4;
            _this.MapDivTop = _this.MenuList4[0];
          }

          if(_this.Flag != '') {
            _this.MapDivTop.industryTypeName = _this.Flag == 1 ? '会计咨询' : _this.Flag == 2 ? '法律服务' : _this.Flag == 3 ? '人力资源' : '广告营销'
            setTimeout(function(){
              _this.upGeocoder(_this.MapDivTop)
            },500)
          }
        }
      });
    },
    initMap() {
      this.AMapAct = new AMap.Map("mapDiv", {
        resizeEnable: true,
        zoom: 9
      });
      this.infoWindow = new AMap.InfoWindow({offset: new AMap.Pixel(10, -30)});
    },
    Geocoder (val) {
      let _this = this;
      this.geocoder = new AMap.Geocoder({
        city: "010", //城市设为北京，默认：“全国”
      });
      var icon = new AMap.Icon({
        size: new AMap.Size(25, 34),    // 图标尺寸
        image: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',  // Icon的图像
      });
      _this.marker = new AMap.Marker({
          icon: icon,
          position: [val.addressLatitude, val.addressLongitude],
      });
      _this.AMapAct.add(_this.marker);
    },
    markerClick(e) {
      let _this = this;
      _this.infoWindow.setContent(e.target.content);
      _this.infoWindow.open(_this.AMapAct, e.target.getPosition());
    },
    clickMenu (val,Index) { // 点击左侧菜单调用获取地图数据
      this.Flag = Index;
      this.MapDivTop = val
      this.MapDivTop.industryTypeName = Index == 1 ? '会计咨询' : Index == 2 ? '法律服务' : Index == 3 ? '人力资源' : '广告营销'
      this.upGeocoder(val)
    },
    upGeocoder (val) {
      let _this = this;
      _this.AMapAct.remove(_this.marker2 || '');
      var icon = new AMap.Icon({
        size: new AMap.Size(25, 34),    // 图标尺寸
        image: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png',  // Icon的图像
      });
      _this.marker2 = new AMap.Marker({
          icon: icon,
          position: [val.addressLatitude, val.addressLongitude],
      });
      _this.marker2.content = val.name;
      _this.marker2.on('click', this.markerClick);
      _this.marker2.emit('click', {target: this.marker2});
      _this.AMapAct.add(_this.marker2);
    },
    //构建自定义信息窗体
    createInfoWindow(title, content) {
        var info = document.createElement("div");
        info.className = "custom-info input-card content-window-card";
        //可以通过下面的方式修改自定义窗体的宽高
        info.style.width = "200px";
        // 定义顶部标题
        var top = document.createElement("div");
        var titleD = document.createElement("div");
        var closeX = document.createElement("img");
        top.className = "info-top";
        titleD.innerHTML = title;
        closeX.src = "https://webapi.amap.com/images/close2.gif";
        closeX.onclick = closeInfoWindow;

        top.appendChild(titleD);
        top.appendChild(closeX);
        info.appendChild(top);

        // 定义中部内容
        var middle = document.createElement("div");
        middle.className = "info-middle";
        middle.style.backgroundColor = 'white';
        middle.innerHTML = content;
        info.appendChild(middle);

        // 定义底部内容
        var bottom = document.createElement("div");
        bottom.className = "info-bottom";
        bottom.style.position = 'relative';
        bottom.style.top = '0px';
        bottom.style.margin = '0 auto';
        var sharp = document.createElement("img");
        sharp.src = "https://webapi.amap.com/images/sharp.png";
        bottom.appendChild(sharp);
        info.appendChild(bottom);
        return info;
    },
    //关闭信息窗体
    closeInfoWindow() {
      map.clearInfoWindow();
    },
    Mark () {
      let title = `${extData.name}`
      let content = [];
      content.push(`<span class="content-main">${validationField(extData.districtName)}</span>`)
      let InfoOptions = {
          isCustom: true,  //使用自定义窗体
          offset: new AMap.Pixel(16, -45),
          content: createInfoWindow(title, content.join("<br/>")),
      }
      let infoWindow = new AMap.InfoWindow(InfoOptions)
      infoWindow.open(map, e.target._position);
    },
    viewDetails () {
      this.$router.push({path: '/bjent/info', query: {id: this.MapDivTop.id}});
    },
    handleSelect(val) {
      if(val == 1) {
        this.$router.push({path: '/show/map',query:{}});
      } else{
        this.$router.push({path: '/show/mapbj',query:{}});
      }
    },
    more() {
      this.$router.push({path: '/show/more', query: {}});
    },
    handleOpen(key) {
      this.Flag = String(key)
    },
    closeBox() {
      this.showAdbox = false;
      clearInterval(this.itl)
    },
    leaveBox() {
      if (this.showAdbox == false) {
        clearInterval(this.itl)
      } else {
        this.itl = setInterval(this.movebox, this.delay)
      }
    },
    enterBox() {
      clearInterval(this.itl)
    },
    movebox() {
      var L = 0;
      var T = 0;
      var R = document.documentElement.clientWidth - this.$refs.adbox.offsetWidth;    //浏览器显示宽度-adbox宽度，不随滚动条变化而变化
      var B = document.documentElement.clientHeight - this.$refs.adbox.offsetHeight;  //浏览器显示高度-adbox高度，不随滚动条变化而变化
      this.$refs.adbox.style.left = this.x + document.documentElement.scrollLeft + "px";  //adbox初始左+滚动条最左端到浏览器最左端的距离
      this.$refs.adbox.style.top = this.y + document.documentElement.scrollTop + "px";    //adbox初始高+滚动条顶端到浏览器顶端的距离
      this.x = this.x + this.step * (this.xin ? 1 : -1);
      if (this.x < L) {
        this.xin = true;
        this.x = L;
      }
      if (this.x > R) {
        this.xin = false;
        this.x = R;
      }
      this.y = this.y + this.step * (this.yin ? 1 : -1);
      if (this.y < T) {
        this.yin = true;
        this.y = T;
      }
      if (this.y > B) {
        this.yin = false;
        this.y = B;
      }
    },
    routeEnterShowAdbox() {
      this.itl = setInterval(this.movebox, this.delay)
    },
  }
}
</script>

<style scoped>
nav .el-menu-demo, .el-menu--horizontal, .el-menu {
  background: hsla(0,0%,100%,0)!important;
}
.el-menu--horizontal>.el-menu-item{
  padding: 0px 44px;
  font-size: 20px;
  height: 59px;
  line-height: 59px;
}
.el-menu-demo li {
  background: #BA0132 !important;
  color: white !important;
}
.el-menu-demo li:hover {
  background: #BA0132 !important;
}
.el-menu.el-menu--horizontal{
  border: none !important;
}
.el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: 1px solid white !important;
  background: #990012 !important;
}
.headCenter {
  height: 100%;
  display: flex;
  align-items: center;
  color: white;
  font-size: 24px;
  font-family: '方正正中黑简体';
}

.Center1200 {
  width: 1200px;
  margin: 0 auto;
}

.mapDiv {
  width: 100%;
  height: 600px;
}

.searchForm {
  width: 700px;
}

nav {
  height: 60px !important;
  background: #BA0132;
}

nav a {
  font-size: 14px;
  color: white;
}

.conHeader {
  width: 100%;
  border-bottom: 1px solid #D7D7D7;
  padding: 15px 0;
  margin-bottom: 30px;
}

form {
  display: flex;
  align-items: center;
}

.width45 {
  width: 28.6%;
  margin: 0;
}

.width6 {
  width: 6%;
  margin: 0;
}

form > div .el-form-item__label {
  width: 100px;
}

.conBottom {
  display: flex;
}

.Right {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-left: 20px;
}

.mapDivTop {
  width: 100%;
  height: 60px;
  border: 1px solid rgb(252, 225, 189);
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mapDivTop > h2 {
  margin-left: 20px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mapDivTop h2 > p {
  width: 64px;
  height: 16px;
  font-size: 14px;
  color: rgb(249, 177, 144);
  background: rgb(253, 240, 220);
  padding: 3px 8px;
  margin: 0px 5px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mapDivTop > span {
  font-size: 14px;
}

.mapDivTop > div {
  width: 100px;
  height: 100%;
  font-size: 14px;
  margin-right: -1px;
  color: #A30014;
  background: rgb(252, 225, 189);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.el-menu ul li,
.el-menu {
  background: white !important;
}

.mapDiv {
  position: relative;
}

.MapDiver {
  font-size: 20px;
  color: white;
  position: absolute;
  left: 28%;
  z-index: 499;
  display: flex;
}

.box, .box3 {
  width: 0;
  height: 0;
  border-top: 30px solid rgb(245, 154, 35);
  border-right: 30px solid rgba(0, 0, 0, 0);
  border-bottom: 30px solid rgba(0, 0, 0, 0);
  border-left: 30px solid rgba(0, 0, 0, 0);
  margin-top: -30px;
}

.box2 {
  width: 280px;
  height: 30px;
  background-color: rgb(245, 154, 35);
  line-height: 30px;
}

.box {
  transform: translate(30px, 30px);
}

.box3 {
  transform: translate(-30px, 30px);
}

.el-menu-item-group > ul {
  max-height: 445px !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}

#adbox {
  width: 231px;
  position: absolute;
  z-index: 999;
}

#adbox img {
  border: none;
  cursor: pointer;
}

#adbox b {
  position: absolute;
  right: 5px;
  top: 0;
  cursor: pointer;
  color: white;
}
.centerWidth100{
  width: 100%;
  position: relative;
}
</style>
